<template>
  <div :style="{ fontSize: fontSize + 'px' }" class="font-weight-bold text-truncate">
    {{ units }}<sup>{{ cents }}</sup><span> {{ currency }}</span>
  </div>
</template>

<script>
  export default {
    props: {
      price: {
        type: [String, Number],
        default: 0
      },
      currency: {
        type: String,
        default: 'RON'
      },
      fontSize: {
        type: Number,
        default: 14
      },
      decimals: {
        type: Number,
        default: 2
      }
    },
    computed: {
      units() {
        if (this.price === 0 || this.price === null || this.price === "0") {
          return
        }
        return this.price.toString().split('.')[0];
      },
      cents() {
        if (this.price === 0 || this.price === null) {
          return
        }
        let cents = this.price.toString().split('.')[1];
        if (cents) {
          let rounding = cents.substring(0, this.decimals);
          if (rounding.length > 1) {
            return rounding;
          } else {
            return rounding + '0';
          }
        } else {
          return '00';
        }
      }
    },
  }
</script>
